import React from 'react';
//import ReactDOM from "react-dom/client";

import "bootstrap/dist/css/bootstrap.min.css";
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';

class Demo1 extends React.Component {
  constructor(props) {    
    super(props); 
    this.state = { 
      prova: 1,
    };    
  }
  render() {
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />

    return (
      <div>
        <div className="border container-sm">DEMO 1</div>
      </div>          
    )
  }
}

export default Demo1;
